<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "practice-users"
};
</script>

<style lang="scss"></style>
